
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2233',
  depVersions: {
  "customer-portal-app": "static-1.2233",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9647",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.446",
  "growth-payments-core": "static-1.25295",
  "head-dlb": "static-1.4994",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5571",
  "hs-test-utils": "static-1.7989",
  "hub-http": "static-1.6197",
  "hub-http-shared-msw-handlers": "static-1.9899",
  "hubspot-dlb": "static-2.1845",
  "hubspot-prosemirror": "static-1.18168",
  "hubspot-url-utils": "static-1.4115",
  "HubStyleTokens": "static-2.11443",
  "I18n": "static-7.1617",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6442",
  "payment-link-components": "static-1.23459",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6994",
  "quartz-core": "static-1.6213",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10185",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5323",
  "rich-text-lib": "static-1.19782",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17948",
  "ui-components-test-utils": "static-1.5580",
  "UIComponents": "static-3.8389",
  "foundations-assets": "static-1.4839",
  "foundations-components": "static-1.7882",
  "foundations-theming": "static-1.4395",
  "foundations-theming-specialty": "static-1.2111",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9619",
  "PortalIdParser": "static-2.397",
  "portals-platform-lib": "static-1.862",
  "quartz-config": "static-1.772",
  "quartz-routing": "static-1.424",
  "quick-fetch": "static-1.3895",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16644",
  "rpc-client-utils": "static-1.4627",
  "sanitize-text": "static-1.8118",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4743",
  "ui-addon-react-router-dom": "static-1.9519",
  "usage-tracker": "static-1.7321",
  "usage-tracker-anonymous": "static-1.5738",
  "usage-tracker-core": "static-1.7171",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven": "static-3.5907",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3382",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3271",
  "quartz-webpack": "static-1.3218",
  "bend-plugin-quartz-routing": "static-1.72",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7638",
  "frontend-preferences-client": "static-1.7904",
  "laboratory-lib": "static-3.7134",
  "onboarding-scopes": "static-1.6437",
  "ui-addon-opt": "static-4.8347",
  "HeadJS": "static-2.751",
  "hs-test-utils-bend-plugin": "static-1.3100",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.64",
  "ts-schema": "static-1.4059",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7711",
  "cssUtils": "static-1.785",
  "customer-data-ui-utilities": "static-1.9801",
  "HubStyle": "static-2.11750",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.669",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9864",
  "ui-addon-i18n": "static-1.11127",
  "ui-business-units-lib": "static-1.9026",
  "ui-shepherd-react": "static-3.10132",
  "video-components-external": "static-1.11181",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4302",
  "commerce-tours-lib": "static-1.6044",
  "customer-data-properties": "static-1.51449",
  "getting-started-shared-tasks": "static-1.18427",
  "growth-onboarding-reliability": "static-1.5058",
  "onboarding-tours": "static-1.16548",
  "reference-resolvers-lite": "static-1.8070",
  "sales-checkout-service-client": "static-1.3614",
  "ui-addon-iframeable": "static-1.9032",
  "user-context": "static-1.5078",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4631",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.526",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.669",
  "quartz-head": "static-1.659",
  "quartz-test": "static-1.669",
  "quartz-tracking": "static-1.373",
  "ui-fonts": "static-1.705",
  "usage-tracker-container": "static-1.7311",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9403",
  "data-token-picker": "static-1.16360",
  "FileManagerLib": "static-1.39185",
  "property-translator": "static-1.5376",
  "atom": "static-1.5047",
  "merchandise-lib": "static-1.263",
  "purchase-motions-components": "static-1.5840",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5365",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1146",
  "bend-plugin-foundations-components": "static-1.4151",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "trellis-assets": "static-1.1786",
  "bend-plugin-foundations-theming": "static-1.2878",
  "foundations-theming-base": "static-1.3380",
  "stylex": "static-1.32",
  "interframe": "static-3.4736",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5735",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.37",
  "chirp-fetch": "static-1.1862",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4453",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3171",
  "inbound-db-properties-service-client": "static-1.3825",
  "superstore": "static-1.4740",
  "feedback-loader": "static-1.29246",
  "ai-components-ui-library": "static-1.8870",
  "ui-addon-video-player": "static-1.8678",
  "ui-coaching-tips": "static-1.28474",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4595",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2473",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8144",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4625",
  "content-media-composition-data-lib": "static-1.12169",
  "content-media-compositions": "static-2.16176",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4129",
  "magpie-lib": "static-1.5538",
  "magpie-types": "static-1.4998",
  "media-bridge-lib": "static-1.18878",
  "video-data-lib": "static-1.34839",
  "commerce-products-lib": "static-1.9457",
  "crm-message-bus": "static-1.42918",
  "growth-data-modal": "static-1.5387",
  "hubspot-apollo-client": "static-1.4852",
  "onboarding-tours-client": "static-1.4762",
  "calling-global-api": "static-1.64426",
  "calling-internal-common": "static-1.31277",
  "calling-lifecycle-internal": "static-1.65808",
  "calling-lifecycle-messages": "static-1.58102",
  "conditional-properties-service-client": "static-1.3776",
  "crm-links": "static-1.6260",
  "customer-data-objects-ui-components": "static-1.13000",
  "customer-data-properties-shared-msw-handlers": "static-1.9226",
  "customer-data-property-utils": "static-1.8063",
  "external-options-client-types": "static-1.4137",
  "file-manager-components": "static-1.23545",
  "framework-data-schema-resolvers": "static-1.6858",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.128",
  "inbound-db-meta-service-client": "static-1.3569",
  "inbounddb-objects-service-types": "static-1.4202",
  "meetings-icalendar-utils-lib": "static-1.607",
  "multi-currency-client-types": "static-1.3670",
  "object-builder-ui-client": "static-1.48644",
  "pipeline-validation-client-types": "static-1.3944",
  "property-value-citations": "static-1.2063",
  "pulse": "static-1.545",
  "smart-property-lib": "static-1.6788",
  "tiered-pricing": "static-1.1144",
  "ui-addon-form-validation": "static-1.10968",
  "growth-onboarding-confetti": "static-1.3042",
  "growth-onboarding-next-action-utils": "static-1.1843",
  "navigation-components": "static-1.17956",
  "onboarding-tours-utils": "static-1.614",
  "ui-shepherd-tracker": "static-1.7513",
  "ui-universal-auth": "static-1.8947",
  "batch-promise": "static-1.1515",
  "navigation-messaging": "static-1.7283",
  "getting-started-shared-tasks-store": "static-1.17545",
  "hubspotter-http-shared-msw-handlers": "static-1.9897",
  "usage-tracker-session-replay": "static-1.5007",
  "audio-components": "static-1.5876",
  "FileManagerCore": "static-1.39044",
  "FileManagerImages": "static-1.36696",
  "video-components": "static-1.13184",
  "foundations-components-legacy": "static-1.907",
  "purchase-motions-api": "static-1.5843",
  "self-service-api": "static-1.10222",
  "signup-constants": "static-1.18797",
  "signup-ui-url-generator": "static-2.8018",
  "trials-service-types": "static-1.3878",
  "usage-tracker-public": "static-1.7132",
  "chatspot-core": "static-1.21159",
  "ContentUtils": "static-1.68281",
  "copilot-toolkit": "static-1.11068",
  "growth-onboarding-feedback-components": "static-1.6557",
  "reactive-lib": "static-1.697",
  "simple-logging-lib": "static-1.3024",
  "commerce-permissions": "static-1.742",
  "customer-data-tracking": "static-1.6863",
  "products-iframe-lib": "static-1.7857",
  "products-ui-components-shared-msw-handlers": "static-1.10281",
  "onboarding-data-sync-lib": "static-1.1916",
  "hubspot-apollo-cache": "static-1.311",
  "calling-error-reporting": "static-1.31284",
  "shared-worker-versioning": "static-1.11013",
  "calling-usage-tracker": "static-1.6518",
  "voice-sms-access-library": "static-1.869",
  "conversations-skeleton-state": "static-1.7223",
  "location-customization-utils-lib": "static-1.9169",
  "crm-pipelines-api-client-types": "static-1.4121",
  "framework-builder-read-service-client": "static-1.3988",
  "framework-data-schema-quick-fetch": "static-1.6763",
  "persist-promise": "static-1.3672",
  "bend-plugin-pulse": "static-1.48",
  "directed-graph": "static-1.910",
  "event-emitter": "static-1.923",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.152",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9982",
  "fsm": "static-1.3706",
  "policy-lib": "static-1.6753",
  "react-tinymce": "static-1.55165",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10045",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54291",
  "tinymce-plugins": "static-1.57405",
  "tinymce-themes": "static-1.56261",
  "growth-onboarding-next-action-components": "static-1.1871",
  "user-context-client": "static-1.4587",
  "nest": "static-1.202",
  "unified-auth-core-lib": "static-1.743",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4512",
  "video-embed": "static-1.35673",
  "content-icons-ui": "static-1.2219",
  "social-insights-client-types": "static-1.22006",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4787",
  "integrations-lib": "static-1.16025",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4239",
  "InboxConnectUtils": "static-4.14738",
  "calling-orchestration-schema": "static-1.35646",
  "crm-record-cards-service-types": "static-1.3587",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4491",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.3017",
  "tinymce-data": "static-1.40376",
  "ui-addon-sales-email": "static-1.5186",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12394",
  "layout-dnd-utils": "static-1.11369",
  "react-codemirror": "static-1.10600",
  "ui-brand-identity-lib": "static-1.15156",
  "NamespacedHubStyle": "static-2.9040",
  "outpost": "static-1.4161",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13440",
  "integrations-tracking-lib": "static-1.5574",
  "native-integrations-shared-strings": "static-1.7758",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10345",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.461",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68356",
  "layout-data-lib": "static-1.9694",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2988",
  "google-sheets-integration-lib": "static-1.155",
  "microsoft-drive-integration-lib": "static-1.271",
  "advanced-menus-core": "static-1.15089",
  "advanced-menus-lib": "static-1.12034",
  "ExportDialog": "static-6.10367",
  "ui-memberships-settings-lib": "static-1.33971",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15088",
  "simple-menus-lib": "static-1.16605"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2233",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9647",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.446",
  "growth-payments-core": "/growth-payments-core/static-1.25295",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5571",
  "hs-test-utils": "/hs-test-utils/static-1.7989",
  "hub-http": "/hub-http/static-1.6197",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9899",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18168",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyleTokens": "/HubStyleTokens/static-2.11443",
  "I18n": "/I18n/static-7.1617",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6442",
  "payment-link-components": "/payment-link-components/static-1.23459",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6994",
  "quartz-core": "/quartz-core/static-1.6213",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5323",
  "rich-text-lib": "/rich-text-lib/static-1.19782",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17948",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5580",
  "UIComponents": "/UIComponents/static-3.8389",
  "foundations-assets": "/foundations-assets/static-1.4839",
  "foundations-components": "/foundations-components/static-1.7882",
  "foundations-theming": "/foundations-theming/static-1.4395",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2111",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9619",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "portals-platform-lib": "/portals-platform-lib/static-1.862",
  "quartz-config": "/quartz-config/static-1.772",
  "quartz-routing": "/quartz-routing/static-1.424",
  "quick-fetch": "/quick-fetch/static-1.3895",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16644",
  "rpc-client-utils": "/rpc-client-utils/static-1.4627",
  "sanitize-text": "/sanitize-text/static-1.8118",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4743",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9519",
  "usage-tracker": "/usage-tracker/static-1.7321",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5738",
  "usage-tracker-core": "/usage-tracker-core/static-1.7171",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven": "/raven/static-3.5907",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3382",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3271",
  "quartz-webpack": "/quartz-webpack/static-1.3218",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.72",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7638",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7904",
  "laboratory-lib": "/laboratory-lib/static-3.7134",
  "onboarding-scopes": "/onboarding-scopes/static-1.6437",
  "ui-addon-opt": "/ui-addon-opt/static-4.8347",
  "HeadJS": "/HeadJS/static-2.751",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3100",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.64",
  "ts-schema": "/ts-schema/static-1.4059",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7711",
  "cssUtils": "/cssUtils/static-1.785",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9801",
  "HubStyle": "/HubStyle/static-2.11750",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.669",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9864",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11127",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9026",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10132",
  "video-components-external": "/video-components-external/static-1.11181",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4302",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6044",
  "customer-data-properties": "/customer-data-properties/static-1.51449",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18427",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5058",
  "onboarding-tours": "/onboarding-tours/static-1.16548",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8070",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3614",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9032",
  "user-context": "/user-context/static-1.5078",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4631",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.526",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.669",
  "quartz-head": "/quartz-head/static-1.659",
  "quartz-test": "/quartz-test/static-1.669",
  "quartz-tracking": "/quartz-tracking/static-1.373",
  "ui-fonts": "/ui-fonts/static-1.705",
  "usage-tracker-container": "/usage-tracker-container/static-1.7311",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9403",
  "data-token-picker": "/data-token-picker/static-1.16360",
  "FileManagerLib": "/FileManagerLib/static-1.39185",
  "property-translator": "/property-translator/static-1.5376",
  "atom": "/atom/static-1.5047",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "purchase-motions-components": "/purchase-motions-components/static-1.5840",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5365",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1146",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4151",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "trellis-assets": "/trellis-assets/static-1.1786",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2878",
  "foundations-theming-base": "/foundations-theming-base/static-1.3380",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4736",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5735",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.37",
  "chirp-fetch": "/chirp-fetch/static-1.1862",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4453",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3825",
  "superstore": "/superstore/static-1.4740",
  "feedback-loader": "/feedback-loader/static-1.29246",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8870",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8678",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28474",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4595",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2473",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8144",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4625",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12169",
  "content-media-compositions": "/content-media-compositions/static-2.16176",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4129",
  "magpie-lib": "/magpie-lib/static-1.5538",
  "magpie-types": "/magpie-types/static-1.4998",
  "media-bridge-lib": "/media-bridge-lib/static-1.18878",
  "video-data-lib": "/video-data-lib/static-1.34839",
  "commerce-products-lib": "/commerce-products-lib/static-1.9457",
  "crm-message-bus": "/crm-message-bus/static-1.42918",
  "growth-data-modal": "/growth-data-modal/static-1.5387",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4852",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4762",
  "calling-global-api": "/calling-global-api/static-1.64426",
  "calling-internal-common": "/calling-internal-common/static-1.31277",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65808",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58102",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3776",
  "crm-links": "/crm-links/static-1.6260",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13000",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9226",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8063",
  "external-options-client-types": "/external-options-client-types/static-1.4137",
  "file-manager-components": "/file-manager-components/static-1.23545",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6858",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.128",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3569",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4202",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.607",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3670",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48644",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3944",
  "property-value-citations": "/property-value-citations/static-1.2063",
  "pulse": "/pulse/static-1.545",
  "smart-property-lib": "/smart-property-lib/static-1.6788",
  "tiered-pricing": "/tiered-pricing/static-1.1144",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10968",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3042",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1843",
  "navigation-components": "/navigation-components/static-1.17956",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.614",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7513",
  "ui-universal-auth": "/ui-universal-auth/static-1.8947",
  "batch-promise": "/batch-promise/static-1.1515",
  "navigation-messaging": "/navigation-messaging/static-1.7283",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17545",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9897",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5007",
  "audio-components": "/audio-components/static-1.5876",
  "FileManagerCore": "/FileManagerCore/static-1.39044",
  "FileManagerImages": "/FileManagerImages/static-1.36696",
  "video-components": "/video-components/static-1.13184",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.907",
  "purchase-motions-api": "/purchase-motions-api/static-1.5843",
  "self-service-api": "/self-service-api/static-1.10222",
  "signup-constants": "/signup-constants/static-1.18797",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8018",
  "trials-service-types": "/trials-service-types/static-1.3878",
  "usage-tracker-public": "/usage-tracker-public/static-1.7132",
  "chatspot-core": "/chatspot-core/static-1.21159",
  "ContentUtils": "/ContentUtils/static-1.68281",
  "copilot-toolkit": "/copilot-toolkit/static-1.11068",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6557",
  "reactive-lib": "/reactive-lib/static-1.697",
  "simple-logging-lib": "/simple-logging-lib/static-1.3024",
  "commerce-permissions": "/commerce-permissions/static-1.742",
  "customer-data-tracking": "/customer-data-tracking/static-1.6863",
  "products-iframe-lib": "/products-iframe-lib/static-1.7857",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10281",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1916",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.311",
  "calling-error-reporting": "/calling-error-reporting/static-1.31284",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11013",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6518",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.869",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7223",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9169",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4121",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3988",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6763",
  "persist-promise": "/persist-promise/static-1.3672",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.48",
  "directed-graph": "/directed-graph/static-1.910",
  "event-emitter": "/event-emitter/static-1.923",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.152",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9982",
  "fsm": "/fsm/static-1.3706",
  "policy-lib": "/policy-lib/static-1.6753",
  "react-tinymce": "/react-tinymce/static-1.55165",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10045",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54291",
  "tinymce-plugins": "/tinymce-plugins/static-1.57405",
  "tinymce-themes": "/tinymce-themes/static-1.56261",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1871",
  "user-context-client": "/user-context-client/static-1.4587",
  "nest": "/nest/static-1.202",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.743",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4512",
  "video-embed": "/video-embed/static-1.35673",
  "content-icons-ui": "/content-icons-ui/static-1.2219",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4787",
  "integrations-lib": "/integrations-lib/static-1.16025",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4239",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14738",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35646",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4491",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.3017",
  "tinymce-data": "/tinymce-data/static-1.40376",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5186",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12394",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11369",
  "react-codemirror": "/react-codemirror/static-1.10600",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15156",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9040",
  "outpost": "/outpost/static-1.4161",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13440",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5574",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7758",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10345",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.461",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68356",
  "layout-data-lib": "/layout-data-lib/static-1.9694",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2988",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.155",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.271",
  "advanced-menus-core": "/advanced-menus-core/static-1.15089",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12034",
  "ExportDialog": "/ExportDialog/static-6.10367",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33971",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15088",
  "simple-menus-lib": "/simple-menus-lib/static-1.16605"
}
};
